import { AxiosHttpGet, AxiosHttpPost } from 'axios-http';
import { REPAIR_CENTER } from 'resources/links';

export function getOsDetails(data: { id: number; rmaId: number }) {
    return AxiosHttpGet({
        url: REPAIR_CENTER.getOsDetails,
        data: data
    });
}

export function updateStatusOS(data: { numberOS: string | number }) {
    return AxiosHttpPost({
        url: REPAIR_CENTER.updateStatusOS,
        data: data,
    });
}

export function sendBudgetNotification(data: {
    rmaId: number;
    osId: number;
    url: string;
}[]) {
    return AxiosHttpPost({
        url: REPAIR_CENTER.sendBudgetNotification,
        data: data
    })
}